import React from 'react'
import ReactDOM from 'react-dom'

import { Provider } from 'react-redux'

import App from './App'
import { store } from './store'

import 'antd/dist/antd.css'

import './styles/GlobalStyle.scss'

ReactDOM.render(
  <>
    <Provider store={store}>
      <App />
    </Provider>
  </>,
  document.getElementById('root')
)
